// External libraries
import React from 'react';
import {
  FloatingLabelInput,
  FullName,
  validateName,
  // @ts-expect-error TODO:@checkout/react-components
} from '@checkout/react-components';
import { useStoreState } from '@/store';

// Internal modules
import { features, getContent } from '@/lib';
import type { HTMLInputHandlers } from '../types';
import { useMountLogging } from '@/lib/reactHooks';
import { MiddleNameInput } from './MiddleNameInput';

export const Name = (props: HTMLInputHandlers): React.ReactElement => {
  useMountLogging('Name');
  const firstName = useStoreState(({ form }) => form.firstName);
  const lastName = useStoreState(({ form }) => form.lastName);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const showMiddleName = features.isActive('shouldDisplayAustraliaMiddleName');
  const theme = features.get('rebrandFormFieldsTheme');

  if (showMiddleName) {
    return (
      <>
        <FloatingLabelInput
          autoComplete="given-name"
          data-testid="firstNameInput"
          disabled={isFormSubmitting}
          hasError={firstName?.displayError}
          id="firstName"
          label={getContent('fieldLabels.firstName')}
          maxLength="100"
          name="fname"
          required={true}
          theme={theme}
          type="text"
          {...firstName}
          {...props}
          validationFn={validateName}
        />
        <MiddleNameInput />
        <FloatingLabelInput
          autoComplete="family-name"
          data-testid="lastNameInput"
          disabled={isFormSubmitting}
          hasError={lastName?.displayError}
          id="lastName"
          label={getContent('fieldLabels.lastName')}
          maxLength="100"
          name="lname"
          required={true}
          theme={theme}
          type="text"
          {...lastName}
          {...props}
          validationFn={validateName}
        />
      </>
    );
  }

  return (
    <FullName
      disabled={isFormSubmitting}
      firstName={firstName}
      labels={{
        firstName: getContent('fieldLabels.firstName'),
        lastName: getContent('fieldLabels.lastName'),
      }}
      lastName={lastName}
      {...props}
    />
  );
};
